module.exports = __webpack_public_path__ + "static/img/MM064_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/MM064_1.png
// module id = VZDo
// module chunks = 0